import type { TrackLoginRequest, TrackLoginResponse } from '../services/api';

export function createTrackLoginRequest(userId: string): TrackLoginRequest {
  return {
    userID: userId,
    loginTime: new Date().toISOString(),
  };
}

export function shouldShowOnboarding(loginResponse: TrackLoginResponse): {
  showOnboarding: boolean;
  isFirstLogin: boolean;
  isThirdDay: boolean;
  dotsAwarded: number;
} {
  const { data } = loginResponse;
  return {
    showOnboarding: !data.onboardingCompleted,
    isFirstLogin: data.isFirstLogin,
    isThirdDay: data.isThirdDay,
    dotsAwarded: data.dotsAwarded || 0,
  };
}

export function shouldShowRewardPopup(loginResponse: TrackLoginResponse): {
  showReward: boolean;
  isThirdDay: boolean;
  dotsAwarded: number;
  currentStreak: number;
} {
  const { data } = loginResponse;
  return {
    showReward: data.isThirdDay && data.isRewardEligible && !data.rewardClaimed,
    isThirdDay: data.isThirdDay,
    dotsAwarded: data.dotsAwarded || 0,
    currentStreak: data.currentStreak,
  };
}
